import { gradeTypeTitles } from '$variables/constants';

const formatAssignmentOption = ({
  title: assignmentTitle,
  id: assignmentId,
  isDisabled,
  gradeType,
}) => ({
  name: assignmentTitle,
  value: assignmentId,
  isDisabled: !!isDisabled,
  subText: gradeTypeTitles[gradeType],
});

export default formatAssignmentOption;
